import React, { useEffect, useState } from "react";

/** Single starter plan shown in the renew popup (comparison table is backed up). */
const SINGLE_PLAN = {
  name: "Growzaq Plan",
  priceInr: 999,
  days: 30,
  description:
    "One workspace plan for WhatsApp conversations, campaigns, contacts, templates, and team inbox. Renew anytime to keep your project active.",
};

const WHATSAPP_CHARGES_URL =
  "https://developers.facebook.com/docs/whatsapp/pricing";

const PLAN_CHARGES_NOTE =
  "These are the portal management charges. WhatsApp per-message charges will be deducted by Whatsapp from the card linked to your WhatsApp Business Account. To check the WhatsApp per-message charges, please click the link below.";

const RenewPlanModal = ({
  open,
  onClose,
  projectId,
  currentPlanName,
  requirePlan = false,
}) => {
  const [paymentNotice, setPaymentNotice] = useState("");

  useEffect(() => {
    if (!open) {
      setPaymentNotice("");
      return undefined;
    }
    if (requirePlan) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, requirePlan]);

  if (!open) return null;

  const goToPayment = () => {
    setPaymentNotice("Currently this feature is not available");
  };

  return (
    <div className="renew-plan-overlay" role="dialog" aria-modal="true">
      <div className="renew-plan-page renew-plan-page-single">
        {!requirePlan && (
          <button
            type="button"
            className="renew-plan-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        )}

        {requirePlan && (
          <p
            className="renew-state renew-state-error"
            style={{ marginTop: "0.5rem" }}
          >
            Your plan has expired
            {currentPlanName ? ` (${currentPlanName})` : ""}. Please choose a
            plan to continue.
          </p>
        )}

        <h1 className="renew-title">Renew Your Plan</h1>

        <article className="renew-single-plan">
          <div className="renew-single-plan-pricing">
            <h2 className="renew-single-plan-name">{SINGLE_PLAN.name}</h2>
            <p className="renew-single-plan-price">
              ₹{SINGLE_PLAN.priceInr.toLocaleString("en-IN")}
              <sup>+ taxes</sup>
            </p>
            <p className="renew-single-plan-days">{SINGLE_PLAN.days} days</p>
            <button
              type="button"
              className="biz-btn-primary renew-single-plan-cta"
              onClick={goToPayment}
            >
              Proceed to Payment
            </button>
            {paymentNotice ? (
              <p className="renew-single-plan-notice" role="status">
                {paymentNotice}
              </p>
            ) : null}
          </div>
          <div className="renew-single-plan-copy">
            <p className="renew-single-plan-desc">{SINGLE_PLAN.description}</p>
            <aside className="renew-single-plan-note">
              <p>{PLAN_CHARGES_NOTE}</p>
              <a
                href={WHATSAPP_CHARGES_URL}
                target="_blank"
                rel="noreferrer"
                className="renew-single-plan-note-link"
              >
                WhatsApp per-message charges
              </a>
            </aside>
          </div>
        </article>
      </div>
    </div>
  );
};

export default RenewPlanModal;
